import React from 'react';
import {
  createColumnHelper
} from '@tanstack/react-table';
import {
  t
} from 'i18next';

import {
  formatDateRange
} from 'src/shared/utils';
import {
  AdminUnaffiliatedGroup
} from 'src/redux/openapi';

import {
  ActionHandler, GroupActions
} from '../../types';
import * as Style from '../OrgManagementTable.styles';
import {
  EditMenu
} from '../EditMenu';

const groupsColumnHelper = createColumnHelper<AdminUnaffiliatedGroup>();

export const getGroupCols = (
  onAction: ActionHandler<GroupActions>,
  language: string,
) => {
  const columns = [
    groupsColumnHelper.accessor(
      'name',
      {
        header: t('modal.groupName'),
        footer: (props) => props.column.id,
        size: 338,
        minSize: 128,
        cell: (info) => (
          <Style.NameCellSpan>{info.getValue()}</Style.NameCellSpan>
        ),
      }
    ),
    groupsColumnHelper.accessor(
      'admins',
      {
        id: 'admin',
        header: t('common.admin'),
        footer: (props) => props.column.id,
        size: 338,
        minSize: 128,
        cell: (info) => {
          const adminsInfo = info.getValue();

          if (!adminsInfo) {
            return '';
          }

          const superAdmin = adminsInfo?.find(
            ({
              role
            }) => role === 'SUPERADMIN',
          );

          return superAdmin?.email || '';
        },
      }
    ),
    groupsColumnHelper.accessor(
      'admins',
      {
        id: 'subAdmins',
        header: t('common.subAdmins'),
        footer: (props) => props.column.id,
        size: 338,
        minSize: 128,
        cell: (info) => {
          const adminsInfo = info.getValue();

          if (!adminsInfo) {
            return '';
          }

          const admins = adminsInfo
            ?.filter(({
              role
            }) => role === 'ADMIN')
            .map((admin) => admin.email)
            .join(', ');

          return admins;
        },
      }
    ),
    groupsColumnHelper.accessor(
      'memberCount',
      {
        header: () => (
          <Style.CenteredCellText>
            {t('common.usersAmount')}
          </Style.CenteredCellText>
        ),
        footer: (props) => props.column.id,
        size: 108,
        minSize: 108,
        cell: (info) => (
          <Style.RightAlignedCellText>
            {info.getValue()}
          </Style.RightAlignedCellText>
        ),
      }
    ),
    groupsColumnHelper.accessor(
      'createdAt',
      {
        header: t('filters.createDate'),
        footer: (props) => props.column.id,
        minSize: 132,
        cell: (info) => formatDateRange({
          start: info.getValue(),
          language,
        }),
      }
    ),
    groupsColumnHelper.accessor(
      'id',
      {
        id: 'menu-column',
        header: '',
        footer: (props) => props.column.id,
        size: 48,
        cell: (info) => (
          <EditMenu
            type="group"
            id={info.getValue()}
            onAction={onAction}
          />
        ),
      }
    ),
  ];

  return columns;
};
